import { BtnPrimary, Button } from '@/components';
import { trans } from '@/i18n';
import { ConditionalValue, Flex, Text } from '@chakra-ui/react';
import { CSSProperties, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface IProps {
  isAdd?: boolean;
  loading?: boolean;
  path?: string;
  txtAdd?: string;
  txtEdit?: string;
  children?: ReactNode;
  marginTop?: number;
  justifyContent?: ConditionalValue<CSSProperties['justifyContent']>;
  flex?: ConditionalValue<CSSProperties['flex']>;
  hideSubmit?: boolean;
  hideCancel?: boolean;
  disabledSubmit?: boolean;
  onSubmit?: () => void;
  onBack?: () => void;
}

function BaseFormAction(props: IProps) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (props.onBack) {
      props.onBack();
      return;
    }
    if (props.path) {
      navigate(props.path);
      return;
    }
    navigate(-1);
  };

  return (
    <Flex
      flex={props.flex}
      align="center"
      justifyContent={props.justifyContent || 'center'}
      marginTop={props.marginTop !== undefined ? props.marginTop : 30}
      gap={4}
    >
      {!props.hideCancel && (
        <Button
          width={100}
          height={35}
          onClick={handleGoBack}
          type="button"
          colorPalette="gray"
          bgColor="#EDF2F7"
          borderColor="#EDF2F7"
          variant="outline"
        >
          <Text fontSize={14} fontWeight="bold">
            {trans('shared.cancelText')}
          </Text>
        </Button>
      )}
      {props.children}
      {!props.hideSubmit && (
        <BtnPrimary
          className="btn-submit"
          width={100}
          height={35}
          name={
            props.isAdd
              ? trans(props.txtAdd || 'shared.addNew')
              : trans(props.txtEdit || 'shared.update')
          }
          bgColor={props?.disabledSubmit ? '#fff' : ''}
          disabled={props?.disabledSubmit ?? false}
          onClick={props.onSubmit}
          type={props.onSubmit ? 'button' : 'submit'}
        />
      )}
    </Flex>
  );
}

export { BaseFormAction };
